import { useState } from 'react';
import { ProjectInfo } from "../User";
import ProjectCard from "./ProjectCard";

const Projects = () => {
    const [showAll, setShowAll] = useState(false);

    const visibleProjects = showAll ? ProjectInfo : ProjectInfo.slice(0, 6);

    return (
        <div className="px-16 my-10 font-mono md-mx:px-6 " id="Projects">
            <h1 className="text-4xl sm-mx:text-3xl xs-mx:text-2xl text-center mb-10 font-bold text-white">
                <span className="text-primaryColor">02.&nbsp;</span>Projects
            </h1>
            <div className="flex flex-wrap justify-around md-mx:justify-between sm-mx:justify-center gap-4 md-mx:gap-2">
                {visibleProjects.map((project: any, index: number) => (
                    <ProjectCard
                        key={index}
                        title={project.title}
                        desc={project.desc}
                        image={project.image}
                        live={project.live}
                        link={project.link}
                        github={project.github}
                        technologies={project.technologies}
                    />
                ))}
            </div>
            {!showAll && ProjectInfo.length > 6 && (
                <div className="flex justify-center mt-8">
                    <button
                        onClick={() => setShowAll(true)}
                        className="focus-visible:!outline-none text-primaryColor hover:text-white transition-colors duration-300"
                    >
                        ⬇ Show More
                    </button>
                </div>
            )}
        </div>
    );
};

export default Projects;
